const FRAGMENT_ACADEMIC_SLIDER = `
  fragment AcademicSliderFields on CalendarEventInterface {
    title
    url
    startMonth: startDate @formatDateTime(format: "M")
    startDay: startDate @formatDateTime(format: "d")
    endMonth: endDate @formatDateTime(format: "M")
    endDay: endDate @formatDateTime(format: "d")
  }
`;
const ACADEMIC_SLIDER_QUERY = `
  query getEvents($startDate: String!, $related: [QueryArgument]) {
    entries: solspace_calendar {
      events(
        relatedTo: $related
        loadOccurrences: true
        startsAfterOrAt: $startDate
        limit: 12
        calendarId: [4, 2]
      ) {
        ...AcademicSliderFields
      }
    }
  }
  ${FRAGMENT_ACADEMIC_SLIDER}
`;
export {
  ACADEMIC_SLIDER_QUERY
};
//# sourceMappingURL=academic.js.map
